import { useState, useEffect } from "react";
import ProfileDropdown from "./ProfileDropdown";
import { OptimizedSvg } from "@components/common/OptimizedSvg";
import { userProfile } from "@tvet-mis/psda-assets";
import { useProfile } from "./services/GetProfile";
import { useAttachment } from "@hooks/useAttachment";
import { CircularProgress } from "@mui/material";

const Profile = () => {
	const { data } = useProfile();
	const profilePicture = data?.profilePicture;
	const [imageError, setImageError] = useState(false);

	const hasProfilePicture = !!(profilePicture && profilePicture.trim() !== "");

	const isDirectUrl =
		hasProfilePicture &&
		(profilePicture.startsWith("http://") ||
			profilePicture.startsWith("https://") ||
			profilePicture.startsWith("blob:"));
	const { data: fetchedProfileUrl, isLoading: isLoadingProfile } = useAttachment(
		isDirectUrl ? null : (hasProfilePicture ? profilePicture : null),
		!!(hasProfilePicture && !isDirectUrl),
	);
	const profilePictureUrl = isDirectUrl ? profilePicture : fetchedProfileUrl;

	useEffect(() => {
		setImageError(false);
	}, [profilePictureUrl, profilePicture]);

	const avatar = (() => {
		if (profilePictureUrl && !imageError) {
			return (
				<img
					src={profilePictureUrl}
					alt="Profile"
					className="header-profile-avatar__img h-[32px] w-[32px] shrink-0 rounded-full object-cover"
					onError={() => setImageError(true)}
				/>
			);
		}
		if (isLoadingProfile) {
			return (
				<div className="flex h-[30px] w-[30px] shrink-0 items-center justify-center">
					<CircularProgress size={16} />
				</div>
			);
		}
		return (
			<OptimizedSvg
				src={userProfile}
				alt="user profile"
				className="user-profile header-profile-avatar__svg shrink-0 rounded-full"
				cacheKey="user-profile"
				width={30}
				height={30}
			/>
		);
	})();

	return <ProfileDropdown avatar={avatar} />;
};

export default Profile;
